<template>
  <div class="bolt-menu-layout" :class="{ 'bolt-menu-layout--product': !!selectedProduct }">
    <product-options-panel
      v-if="selectedProduct"
      :product="selectedProduct"
      :currency="currency"
      variant="bolt"
      @close="selectedProduct = null"
    />
    <template v-else>
      <aside class="bolt-menu-layout__sidebar">
        <button
          v-for="category in categories"
          :key="category.id"
          type="button"
          class="bolt-menu-layout__nav"
          :class="{ 'is-active': category.id === activeCategoryId }"
          @click="selectCategory(category.id)"
        >
          {{ category.name }}
        </button>
      </aside>
      <div class="bolt-menu-layout__main">
        <h2>{{ activeCategoryName }}</h2>
        <div
          v-for="product in activeProducts"
          :key="product.id"
          class="bolt-menu-layout__row"
          :class="{ 'is-oos': !product.available }"
          @click="product.available !== false && (selectedProduct = product)"
        >
          <div class="bolt-menu-layout__text">
            <div v-if="!product.available" class="bolt-menu-layout__oos">
              {{ $t('gestiune.integrationsMenuPreviewOutOfStock') }}
            </div>
            <h3>{{ product.name }}</h3>
            <p v-if="product.description">{{ truncate(product.description) }}</p>
            <div class="bolt-menu-layout__price">{{ formatPrice(product.price) }}</div>
          </div>
          <div class="bolt-menu-layout__media">
            <img
              v-if="product.image_url"
              :src="product.image_url"
              :alt="product.name"
              :class="{ 'is-muted': !product.available }"
            >
            <button
              v-if="product.available !== false"
              type="button"
              class="bolt-menu-layout__add"
            >+</button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ProductOptionsPanel from './ProductOptionsPanel.vue'

export default {
  name: 'BoltMenuLayout',
  components: { ProductOptionsPanel },
  props: {
    categories: { type: Array, default: () => [] },
    currency: { type: String, default: 'RON' }
  },
  data () {
    return {
      activeCategoryId: null,
      selectedProduct: null
    }
  },
  computed: {
    activeCategory () {
      return (this.categories || []).find((c) => c.id === this.activeCategoryId) || null
    },
    activeCategoryName () {
      return this.activeCategory ? this.activeCategory.name : ''
    },
    activeProducts () {
      return this.activeCategory ? (this.activeCategory.products || []) : []
    }
  },
  watch: {
    categories: {
      immediate: true,
      handler (cats) {
        if (cats && cats.length) this.activeCategoryId = cats[0].id
        this.selectedProduct = null
      }
    }
  },
  methods: {
    selectCategory (id) {
      this.activeCategoryId = id
    },
    truncate (text) {
      const s = String(text || '')
      return s.length > 110 ? s.slice(0, 107) + '...' : s
    },
    formatPrice (price) {
      const n = Number(price)
      if (Number.isNaN(n)) return ''
      return n.toFixed(2).replace('.', ',') + ' ' + this.currency
    }
  }
}
</script>

<style scoped>
.bolt-menu-layout {
  display: flex;
  height: 100%;
  min-height: 0;
  background: #fff;
}
.bolt-menu-layout__sidebar {
  width: 220px;
  flex: 0 0 220px;
  border-right: 1px solid #eee;
  padding: 12px 8px;
  overflow: auto;
}
.bolt-menu-layout__nav {
  display: block;
  width: 100%;
  text-align: left;
  border: 0;
  background: transparent;
  padding: 10px 12px;
  color: #4b5563;
  cursor: pointer;
  border-radius: 8px;
}
.bolt-menu-layout__nav.is-active {
  font-weight: 700;
  color: #111;
  background: #f3f4f6;
}
.bolt-menu-layout__main {
  flex: 1;
  padding: 16px 20px;
  overflow: auto;
}
.bolt-menu-layout__main h2 {
  margin: 0 0 16px;
  font-size: 24px;
  font-weight: 800;
}
.bolt-menu-layout__row {
  display: flex;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}
.bolt-menu-layout__row.is-oos {
  cursor: default;
  opacity: 0.75;
}
.bolt-menu-layout__text {
  flex: 1;
  min-width: 0;
}
.bolt-menu-layout__oos {
  color: #9ca3af;
  font-size: 12px;
  margin-bottom: 4px;
}
.bolt-menu-layout__text h3 {
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 700;
}
.bolt-menu-layout__text p {
  margin: 0 0 8px;
  color: #6b7280;
  font-size: 13px;
}
.bolt-menu-layout__price {
  font-weight: 700;
}
.bolt-menu-layout__media {
  position: relative;
  width: 88px;
  flex: 0 0 88px;
}
.bolt-menu-layout__media img {
  width: 88px;
  height: 88px;
  object-fit: cover;
  border-radius: 10px;
  background: #f3f4f6;
}
.bolt-menu-layout__media img.is-muted {
  filter: grayscale(1);
  opacity: 0.7;
}
.bolt-menu-layout__add {
  position: absolute;
  right: -4px;
  bottom: -4px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 0;
  background: #34d399;
  color: #fff;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}



.bolt-menu-layout__sidebar {
  height: 100%;
}
.bolt-menu-layout__main {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
.bolt-menu-layout--product {
  display: block;
}
.bolt-menu-layout--product > * {
  height: 100%;
}

@media (max-width: 600px) {
  .bolt-menu-layout { flex-direction: column; }
  .bolt-menu-layout__sidebar { display: flex; width: 100%; height: auto; flex: 0 0 auto; overflow-x: auto; border-right: 0; border-bottom: 1px solid #eee; padding: 8px; }
  .bolt-menu-layout__nav { width: auto; flex: 0 0 auto; white-space: nowrap; }
  .bolt-menu-layout__main { min-width: 0; padding: 14px; }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Integrations/MenuPreview/BoltMenuLayout.vue